// extracted by mini-css-extract-plugin
module.exports = {"layout":"Container_layout__fAhNS","currencies":"Container_currencies__EZSYD","reviewBlock":"Container_reviewBlock__RX4JU","hotServicesBlock":"Container_hotServicesBlock__hCtc4"};